import { render } from "./ShareholdersMeetingTable.vue?vue&type=template&id=2a12b3f2&scoped=true"
import script from "./ShareholdersMeetingTable.vue?vue&type=script&lang=js"
export * from "./ShareholdersMeetingTable.vue?vue&type=script&lang=js"

import "./ShareholdersMeetingTable.vue?vue&type=style&index=0&id=2a12b3f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a12b3f2"]])

export default __exports__